<template>
    <div class="float-left">
        <b-modal
            size="lg"
            v-model="mostrarModal"
            no-close-on-backdrop
            @show="preencher()"
        >
            <div slot="modal-title">
                Aplicação de Recursos -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12" md="12">
                    <b-form-group>
                        <label for="Acao">Ação</label>
                        <b-input-group>
                            <b-form-select
                                id="Acao"
                                type="text"
                                :options="acoes"
                                value-field="idAcaoConvenio"
                                text-field="descricao"
                                v-model="idAcaoConvenio"
                            >
                            </b-form-select>
                            <b-form-invalid-feedback
                                >Ação é obrigatória</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="12">
                    <b-form-group>
                        <label>Natureza da Despesa</label>
                        <b-input-group>
                            <model-list-select
                                :list="naturezas"
                                option-text="descricao"
                                option-value="idNaturezaDespesa"
                                v-model="idNaturezaDespesa"
                            >
                            </model-list-select>
                            <b-form-invalid-feedback
                                >Natureza é obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="nuValorEconomicoSebrae"
                            >Suape Valor Econômico</label
                        >
                        <b-input-group>
                            <money
                                id="nuValorEconomicoSebrae"
                                v-model="
                                    aplicacaoRecurso.nuValorEconomicoSebrae
                                "
                                v-bind="money"
                                class="form-control text-right"
                            >
                            </money>
                            <b-form-invalid-feedback
                                >Suape Valor Econômico
                                Obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="nuValorFinanceiroSebrae"
                            >Suape Valor Financeiro</label
                        >
                        <b-input-group>
                            <money
                                id="nuValorFinanceiroSebrae"
                                v-model="
                                    aplicacaoRecurso.nuValorFinanceiroSebrae
                                "
                                v-bind="money"
                                class="form-control text-right"
                            >
                            </money>
                            <b-form-invalid-feedback
                                >Suape Valor Financeiro é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="nuValorEconomicoParceiro"
                            >Parceiro Valor Econômico</label
                        >
                        <b-input-group>
                            <money
                                id="nuValorEconomicoParceiro"
                                v-model="
                                    aplicacaoRecurso.nuValorEconomicoParceiro
                                "
                                v-bind="money"
                                class="form-control text-right"
                            >
                            </money>
                            <b-form-invalid-feedback
                                >Parceiro Valor Econômico é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="nuValorFinanceiroParceiro"
                            >Parceiro Valor Financeiro</label
                        >
                        <b-input-group>
                            <money
                                id="nuValorFinanceiroParceiro"
                                v-model="
                                    aplicacaoRecurso.nuValorFinanceiroParceiro
                                "
                                v-bind="money"
                                class="form-control text-right"
                            >
                            </money>
                            <b-form-invalid-feedback
                                >Parceiro Valor Financeiro é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()">
                    Cancelar
                </b-button>
                <b-button
                    variant="primary"
                    :disabled="this.$v.$invalid"
                    @click.stop="salvar()"
                    class="ml-1"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import ConveniosServicos from '../../ConveniosServicos'
import { ModelListSelect } from 'vue-search-select'

export default {
    components: {
        ModelListSelect
    },

    props: {
        operacaoProp: String,
        mostrarModal: {
            type: Boolean,
            default: () => false
        },
        erros: {
            type: Array,
            default: () => []
        },
        convenio: Object,
        aplicacaoRecurso: Object,
        desativarBotao: Boolean
    },

    validations: {
        idAcaoConvenio: { required },
        idNaturezaDespesa: { required }
    },

    data() {
        return {
            valor: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            naturezas: [],
            acoes: [],

            idNaturezaDespesa: null,
            idAcaoConvenio: null,

            aplicacaoConvenioRecurso: {
                idConvenio: 0,
                idAplicacaoRecurso: 0,
                idNaturezaDespesa: null,
                idAcaoConvenio: null,
                codSituacao: null,
                nuValorFinanceiroSebrae: 0,
                nuValorEconomicoSebrae: 0,
                nuValorFinanceiroParceiro: 0,
                nuValorEconomicoParceiro: 0
            }
        }
    },

    methods: {
        preencher() {
            this.obterAcoes()
            this.obterNaturezas()
            if (this.operacaoProp == 'A') {
                this.idConvenio = this.aplicacaoRecurso.idConvenio
                this.idAplicacaoRecurso =
                    this.aplicacaoRecurso.idAplicacaoRecurso
                this.idNaturezaDespesa = this.aplicacaoRecurso.idNaturezaDespesa
                this.idAcaoConvenio = this.aplicacaoRecurso.idAcaoConvenio
                this.codSituacao = this.aplicacaoRecurso.codSituacao
                this.nuValorFinanceiroSebrae =
                    this.aplicacaoRecurso.nuValorFinanceiroSebrae
                this.nuValorEconomicoSebrae =
                    this.aplicacaoRecurso.nuValorEconomicoSebrae
                this.nuValorFinanceiroParceiro =
                    this.aplicacaoRecurso.nuValorFinanceiroParceiro
                this.nuValorEconomicoParceiro =
                    this.aplicacaoRecurso.nuValorEconomicoParceiro
            }
        },

        obterNaturezas() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterNaturezas().then((response) => {
                if (response) {
                    if (response.success) {
                        this.naturezas = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterAcoes() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterAcoesConvenio(this.convenio.idConvenio).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.acoes = response.data
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        fecharModal() {
            this.$emit('fechar')
            this.resetar()
        },

        salvar() {
            this.$emit('salvar', this.aplicacaoRecurso)
            this.$emit('atualizarListaAplicacaoRecurso')
            this.resetar()
        },

        resetar() {
                (this.idNaturezaDespesa = null),
                (this.idAcaoConvenio = null),
                (this.aplicacaoRecurso.nuValorFinanceiroSebrae = 0),
                (this.aplicacaoRecurso.nuValorEconomicoSebrae = 0),
                (this.aplicacaoRecurso.nuValorFinanceiroParceiro = 0),
                (this.aplicacaoRecurso.nuValorEconomicoParceiro = 0)
        }
    },

    computed: {
        operacao() {
            if (this.operacaoProp == 'I') {
                return 'INCLUSÃO'
            }
            return 'ATUALIZAÇÃO'
        }
    },

    watch: {
        idAcaoConvenio(novo) {
            this.idAcaoConvenio = novo
            this.aplicacaoRecurso.idAcaoConvenio = this.idAcaoConvenio
        },

        idNaturezaDespesa(novo) {
            this.idNaturezaDespesa = novo
            this.aplicacaoRecurso.idNaturezaDespesa = this.idNaturezaDespesa
        }
    }
}
</script>